/**
 * `src/lib/azkar/href.ts` — the azkar routes, through `resolve()` (lint-enforced;
 * see `src/lib/ui/nav/links.ts` for why), and the content URL through
 * `asset()`, so both survive a host with a base path.
 */

import { asset, resolve } from '$app/paths';

export function azkarHref(): string {
	return resolve('/azkar', {});
}

export function azkarSetHref(id: string): string {
	return resolve('/azkar/[set]', { set: id });
}

export function azkarContentUrl(): string {
	return asset('/content/azkar/azkar.json');
}
